var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidePasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66003 13.86C9.78003 13.86 10.18 13.86 10.26 13.86V11.86C10.18 11.86 9.78003 11.86 9.66003 11.86V13.86Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.72 9.27999L18.14 10.7C18.28 10.56 18.44 10.42 18.58 10.28L17.16 8.85999C17.02 8.99999 16.88 9.13999 16.72 9.27999Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.26 13.1C14.44 13.02 14.64 12.96 14.82 12.88L14.06 11.02C13.88 11.1 13.7 11.18 13.5 11.24L14.26 13.1Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84004 8.80005L1.42004 10.2001C1.56004 10.3401 1.70004 10.4801 1.84004 10.6201L3.26004 9.20005C3.12004 9.08005 2.98004 8.94005 2.84004 8.80005Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70001 13.06L6.46001 11.2C6.28001 11.12 6.08001 11.06 5.90001 10.96L5.14001 12.82C5.32001 12.9 5.52001 12.98 5.70001 13.06Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.82 6.41999L17.3 6.12C15.8 8.73999 12.98 10.38 9.95997 10.38C6.93998 10.38 4.13998 8.75999 2.61998 6.14L2.09998 6.44C3.71998 9.23999 6.73997 11 9.95997 11C13.18 11 16.2 9.23999 17.82 6.41999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordIcon);
export default __webpack_public_path__ + "static/media/hide_password_icon.f22d57aed788c43c26a450360cba0850.svg";
export { ForwardRef as ReactComponent };